/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";

import Login from "./pages/Login/login";
import Dashboard from "./pages/Dashboard/dashboard";
import Header from "./components/Header";
import ForgotPassword from "./pages/Forgot-password/ForgotPassword";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import LoadingScreen from "./components/common/LoadingScreen";
import Profile from "./pages/Profile/profile";
import Forward from "./pages/Forward/forward";
import Subscription from "./pages/Subscription/subscription";

import { useProfileData } from "./apis/profileApis";
import { initSocket } from "./socket";
import FillInformation from "./pages/FillInformation/fill-info";
import { useDispatch } from "react-redux";
import {
  addNewOrder,
  addSingleStatusUpdate,
} from "./features/orderStatusHistories/ordersStatusHistoriesSlice";
import { pickupStatusUpdate } from "./features/pickup/pickupSlice";
import { linehaulStatusUpdate } from "./features/linehaul/linehaulSlice";
import { returnToShipperStatusUpdate } from "./features/returnToShipper/returnToShipperSlice";
import { staffUpdate, addStaff } from "./features/staff/staffSlice";
import { addDriver, driverUpdate } from "./features/driver/driverSlice";
import {
  addOutSource,
  outSourceUpdate,
} from "./features/outSource/outSourceSlice";
import { addClient, clientUpdate } from "./features/client/clientSlice";
import {
  setSocketConnected as setDriverMapSocketConnected,
  updateDriverLocation,
  updateMultipleDrivers,
  setDriverOnlineStatus,
  setDrivers,
  MapDriver,
} from "./features/driverMap/driverMapSlice";
import NotificationView from "./pages/Notification/notificationView";
import Payment from "./pages/Subscription/payment";
import FloatingChatButton from "./components/FloatingChatButton";
import SearchResults from "./pages/SearchResults/searchResults";
import {
  addDarkStore,
  darkStoreUpdate,
} from "./features/darkStores/darkStoresSlice";
import { useIdleTimeout } from "./hooks/useIdleTimeout";
import LoginSaudi from "./pages/LoginSaudi/login-saudi";
import ForgotPasswordSaudi from "./pages/Forgot-password-saudi/ForgotPasswordSaudi";
import ChangePasswordSaudi from "./pages/ChangePasswordSaudi/ChangePasswordSaudi";

const playNotificationSound = () => {
  try {
    const audio = new Audio(
      "https://actions.google.com/sounds/v1/alarms/beep_short.ogg",
    );
    audio.play().catch((e) => console.log("Audio play failed:", e));
  } catch (err) { }
};

const showNativeNotification = (
  title: string,
  options?: NotificationOptions,
  onClick?: () => void,
) => {
  if (!("Notification" in window)) return;

  const createNotification = () => {
    const n = new window.Notification(title, options);
    if (onClick) {
      n.onclick = (e) => {
        e.preventDefault();
        window.focus();
        onClick();
        n.close();
      };
    }
    playNotificationSound();
  };

  if (window.Notification.permission === "granted") {
    createNotification();
  } else if (window.Notification.permission !== "denied") {
    window.Notification.requestPermission().then((permission: string) => {
      if (permission === "granted") {
        createNotification();
      }
    });
  }
};

function AppContent() {
  const socketRef = useRef<any>(null);
  const [socketConnected, setSocketConnected] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isSuccess, refetch: fetchProfile } = useProfileData();

  const LoginComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true" ? LoginSaudi : Login;
  const ForgotComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ForgotPasswordSaudi
      : ForgotPassword;
  const ChangePasswordComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ChangePasswordSaudi
      : ChangePassword;

  const isExternalAdmin = process.env.REACT_APP_EXTERNAL_ADMIN === "true";

  useEffect(() => {
    // Update title
    document.title = isExternalAdmin ? "Najiz Express" : "tracktechs";

    // Update favicon
    let link = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      document.head.appendChild(link);
    }
    link.rel = "icon";
    link.href = isExternalAdmin ? "/logo/najizFavicon.png" : "/favicon.ico";
  }, [isExternalAdmin]);

  // 1 minute inactivity timeout for testing
  useIdleTimeout(30 * 60 * 1000);

  const allHideHeaderRoutes = [
    "/",
    "/forgot-password",
    "/password-changed",
    "/create-warehouse",
    "/fill-info",
  ];
  const hideHeader = allHideHeaderRoutes.includes(location.pathname);

  const user = data;

  useEffect(() => {
    if (isSuccess) {
      const isAuthenticated = data && data !== "Invalid or expired token";

      if (
        !isAuthenticated &&
        !allHideHeaderRoutes.includes(location.pathname)
      ) {
        navigate("/");
      } else if (
        isAuthenticated &&
        !data?.isWarehouseCreated &&
        !data?.warehouses?.length &&
        data?.clientType !== "DS"
      ) {
        navigate("/create-warehouse");
      } else if (isAuthenticated && location.pathname === "/") {
        navigate("/dashboard");
      } else if (
        !isAuthenticated &&
        allHideHeaderRoutes.includes(location.pathname)
      ) {
        if (location.pathname === "/fill-info") {
          navigate(`${location.pathname}${location.search}`);
        }
      }
    }
  }, [data, isSuccess, location.pathname, navigate]);

  // Socket setup (single instance)
  useEffect(() => {
    if (
      process.env.REACT_APP_Socket === "true" &&
      user?.id &&
      !socketRef.current
    ) {
      socketRef.current = initSocket();
      const socket = socketRef.current;

      console.log("🔌 Initializing socket:", socket);

      socket.on("connect", () => {
        console.log("✅ Socket Connected!", socket.id);
        setSocketConnected(true);
        socket.emit("setup", {
          id: user.id,
          clientId: user?.clientId || user?.id,
        });
        dispatch(setDriverMapSocketConnected(true));
      });

      socket.on("disconnect", () => {
        console.log("❌ Socket Disconnected!");
        setSocketConnected(false);

        dispatch(setDriverMapSocketConnected(false));
      });

      socket.on("location received", (data: any) => {
        console.log("📍 Location received:", data);
      });

      socket.on("notification Received", (data: any) => {
        console.log("🔔 Notification received:", data);
        fetchProfile();
      });

      socket.on("new-order-status", (data: any) => {
        console.log("🔔 new-order-status:", data);
        dispatch(addSingleStatusUpdate(data));
        // toast.success(`New Status Of Order ${data?.awbNumber}`);
      });

      socket.on("chat-notification", (data: any) => {
        console.log("🔔 Chat notification received:", data);
        const senderName = data.senderName || "Someone";
        toast.success(`New message from ${senderName}`);
        showNativeNotification(
          `Message from ${senderName}`,
          { body: data.message },
          () => {
            if (data.roomId)
              window.location.href = `/help-and-support?chatId=${data.roomId}`;
          },
        );
        // Trigger profile/notifications refresh
        fetchProfile();
      });

      socket.on("ticket-notification", (data: any) => {
        console.log("🔔 Ticket notification received:", data);
        toast.success(`${data.type}: ${data.message}`);
        showNativeNotification(
          `Ticket ${data.type}`,
          { body: data.message },
          () => {
            if (data.ticketId)
              window.location.href = `/help-and-support?ticketId=${data.ticketId}`;
          },
        );
        fetchProfile();
      });

      socket.on("new-chat-message", (data: any) => {
        console.log("🔔 New chat message received:", data);
        if (data?.senderId !== user?.id) {
          const sender = data?.senderType || "Someone";
          showNativeNotification(
            "New Message",
            { body: `New message from ${sender}` },
            () => {
              if (data.roomId)
                window.location.href = `/help-and-support?chatId=${data.roomId}`;
            },
          );
        }
      });

      socket.on("new-order", (data: any) => {
        console.log("🔔 new-order:", data);
        dispatch(addNewOrder(data));
      });

      // socket.on("product", (data: any) => {
      //   console.log("🔔 product:", data);
      //   dispatch(addProduct(data));
      //   toast.success(`Product ${data?.category}`);
      // });

      socket.on("pickup-assign-driver", (data: any) => {
        console.log("🔔 pickup-assign-driver:", data);
        dispatch(pickupStatusUpdate(data));
        // toast.success(`New Status Of pickup ${data?.pickupId}`);
      });

      socket.on("linehaul-status-update", (data: any) => {
        console.log("🔔 linehaul-status-update:", data);
        dispatch(linehaulStatusUpdate(data));
        // toast.success(`New Status Of linehaul ${data?.customId}`);
      });

      socket.on("return-to-shipper-status-update", (data: any) => {
        console.log("🔔 return-to-shipper-status-update:", data);
        dispatch(returnToShipperStatusUpdate(data));
        // toast.success(`New Status Of return to shipper ${data?.returnId}`);
      });

      socket.on("new-staff", (data: any) => {
        console.log("🔔 new-staff:", data);
        dispatch(addStaff(data));
        // toast.success(`Staff update of ${data?.fullName}`);
      });

      socket.on("staff-update", (data: any) => {
        console.log("🔔 staff-update:", data);
        dispatch(staffUpdate(data));
        // toast.success(`Staff update of ${data?.fullName}`);
      });

      socket.on("new-driver", (data: any) => {
        console.log("🔔 new-driver:", data);
        dispatch(addDriver(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("new-dark-store", (data: any) => {
        console.log("🔔 new-dark-store:", data);
        dispatch(addDarkStore(data));
      });

      socket.on("driver-update", (data: any) => {
        console.log("🔔 driver-update:", data);
        dispatch(driverUpdate(data));
        // toast.success(`Driver update of ${data?.name}`);
      });

      socket.on("dark-store-update", (data: any) => {
        console.log("🔔 dark-store-update:", data);
        dispatch(darkStoreUpdate(data));
      });

      socket.on("out-source-update", (data: any) => {
        console.log("🔔 out-source-update:", data);
        dispatch(outSourceUpdate(data));
        // toast.success(`Out Source update of ${data?.companyName}`);
      });

      socket.on("new-outsource", (data: any) => {
        console.log("🔔 new-outsource:", data);
        dispatch(addOutSource(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("client-update", (data: any) => {
        console.log("🔔 client-update:", data);
        dispatch(clientUpdate(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("new-client", (data: any) => {
        console.log("🔔 new-client:", data);
        dispatch(addClient(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      // ==================== Driver Map Socket Events ====================

      socket.on(
        "driver-location-update",
        (data: any) => {
          console.log("Driver location update:", data);
          const driverId = data.id || data.driverId;
          if (!driverId) return;

          const normalizedData = {
            ...data,
            id: String(driverId),
          };

          // Parse coordinates if they come as strings
          if (normalizedData.latitude && normalizedData.longitude) {
            const lat = parseFloat(normalizedData.latitude as string);
            const lon = parseFloat(normalizedData.longitude as string);

            if (!isNaN(lat) && !isNaN(lon)) {
              dispatch(
                updateDriverLocation({
                  ...normalizedData,
                  lat,
                  lon,
                  latitude: String(lat),
                  longitude: String(lon),
                  speed: normalizedData.speed != null ? parseFloat(normalizedData.speed) : undefined,
                  direction: normalizedData.direction != null ? parseFloat(normalizedData.direction) : undefined,
                  freshnessStatus: normalizedData.freshnessStatus || "LIVE",
                  lastSeen: normalizedData.recordedAt || normalizedData.timestamp || new Date().toISOString(),
                  online: true,
                }),
              );
            }
          } else {
            dispatch(updateDriverLocation(normalizedData));
            console.log("Driver location update without lat/lon:", normalizedData);
          }
        },
      );

      socket.on("drivers-batch-update", (data: any[]) => {
        // console.log("Batch driver update:", data.length, "drivers");

        const transformedDrivers = data.map((driver) => {
          const driverId = driver.id || driver.driverId;
          const normalizedDriver = {
            ...driver,
            id: driverId ? String(driverId) : undefined,
          };
          if (normalizedDriver.latitude && normalizedDriver.longitude) {
            const lat = parseFloat(normalizedDriver.latitude as string);
            const lon = parseFloat(normalizedDriver.longitude as string);

            if (!isNaN(lat) && !isNaN(lon)) {
              return {
                ...normalizedDriver,
                lat,
                lon,
                latitude: String(lat),
                longitude: String(lon),
              };
            }
          }
          return normalizedDriver;
        }).filter(d => d.id !== undefined);

        dispatch(updateMultipleDrivers(transformedDrivers));
      });

      // Initial driver data load from socket
      socket.on("initial-driver-data", (data: any[]) => {
        // console.log(
        //   "Initial driver data from socket:",
        //   data.length,
        //   "drivers"
        // );

        const transformedDrivers: MapDriver[] = data
          .map((driver: any) => {
            const lat = parseFloat(driver.latitude || driver.lat);
            const lon = parseFloat(driver.longitude || driver.lon);

            if (isNaN(lat) || isNaN(lon)) {
              console.warn("Invalid coordinates for driver:", driver);
              return null;
            }

            return {
              ...driver,
              id: driver?.id || String(Math.random()),
              name: driver?.name || "Unknown Driver",
              code: driver?.code || "",
              phone: driver?.phone || "",
              email: driver?.email || "",
              vehicle: driver?.vehicle || "Unknown",
              vehicleNumber: driver?.vehicleNumber || "",
              image:
                driver?.image ||
                "https://randomuser.me/api/portraits/men/32.jpg",
              latitude: String(lat),
              longitude: String(lon),
              lat,
              lon,
              speed: driver?.speed || 0,
              direction: driver?.direction || 0,
              accuracy: driver?.accuracy,
              heading: driver?.direction || 0,
              online: driver?.online !== undefined ? driver?.online : true,
              currentLocation:
                driver?.currentLocation ||
                `Lat: ${lat.toFixed(4)}, Lon: ${lon.toFixed(4)}`,
              ordersToday: driver?.ordersToday || 0,
              ordersCompleted: driver?.ordersCompleted || 0,
              rating: driver?.rating || 4.5,
            } as MapDriver;
          })
          .filter((driver): driver is MapDriver => driver !== null);

        dispatch(setDrivers(transformedDrivers));
      });

      socket.on(
        "driver-status-change",
        (data: { id: string; online: boolean }) => {
          console.log("🔄 Driver status changed:", data);
          dispatch(setDriverOnlineStatus(data));
        },
      );

      return () => {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("location received");
        socket.off("notification Received");
        socket.off("chat-notification");
        socket.off("ticket-notification");
        socket.off("new-order-status");
        socket.off("pickup-assign-driver");
        socket.off("linehaul-status-update");
        socket.off("return-to-shipper-status-update");
        socket.off("staff-update");
        socket.off("driver-update");
        socket.off("out-source-update");
        socket.off("client-update");
        socket.off("driver-location-update");
        socket.off("drivers-batch-update");
        socket.off("initial-driver-data");
        socket.off("driver-status-change");
      };
    }
  }, [user?.id]);

  // Emit new notifications
  useEffect(() => {
    if (user && socketRef.current) {
      socketRef.current.emit("New Notification", user);
    }
  }, [user, socketRef.current]);

  if (!isSuccess || data === undefined) {
    return <LoadingScreen />;
  }

  return (
    <div className="bg-gradient-to-tl from-20% to-[#E4E5E7] from-[#F9ECB7] h-screen overflow-hidden overflow-y-auto">
      {!hideHeader && <Header />}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "8px",
            background: "#333",
            color: "#fff",
          },
          success: {
            style: {
              background: "#FBD037",
              color: "#212121",
            },
          },
          error: {
            style: {
              background: "#FF4D4F",
              color: "#fff",
            },
          },
        }}
      />

      <Routes>
        {data && isSuccess && data !== "Invalid or expired token" ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/notification-view" element={<NotificationView />} />

            <Route path="/subscription" element={<Subscription />} />

            <Route path="/forward" element={<Forward />} />
            <Route path="/search-results" element={<SearchResults />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/payment" element={<Payment />} />
          </>
        ) : (
          <>
            <Route path="/fill-info" element={<FillInformation />} />
            <Route path="/" element={<LoginComponent />} />
            {/* <Route path="/" element={<Login />} /> */}
            <Route path="/forgot-password" element={<ForgotComponent />} />
            <Route
              path="/password-changed"
              element={<ChangePasswordComponent />}
            />
          </>
        )}
      </Routes>

      {/* Floating Chat Support */}
      {/* {!hideHeader && <FloatingChatButton />} */}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
